import { render, staticRenderFns } from "./TransferSaveForm.vue?vue&type=template&id=3042a93c&"
import script from "./TransferSaveForm.vue?vue&type=script&lang=js&"
export * from "./TransferSaveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports